export const UPDATE_STYLEBOARD_INFO = 'PPO/UPDATE_STYLEBOARD_INFO';
export const UPDATE_STYLEBOARD_INFO_LOADING = 'PPO/UPDATE_STYLEBOARD_INFO_LOADING';
export const SET_FETCH_STYLEBOARDINFO = 'PPO/SET_FETCH_STYLEBOARDINFO';

export const UPDATE_STYLEBOARD = 'PPO/UPDATE_STYLEBOARD';
export const UPDATE_STYLEBOARD_LOADING = 'PPO/UPDATE_STYLEBOARD_LOADING';
export const SET_FETCH_SPACEDATA = 'PPO/SET_FETCH_SPACEDATA';

export const SET_PHOTO_SUBMIT_SUCCESS = 'PPO/SET_PHOTO_SUBMIT_SUCCESS';
export const SET_PHOTO_WARNING = 'PPO/SET_PHOTO_WARNING';
export const SET_PHOTOS_UPLOADING = 'PPO/SET_PHOTOS_UPLOADING';
export const SET_PHOTOS_UPLOAD_TOTAL = 'PPO/SET_PHOTOS_UPLOAD_TOTAL';
export const SET_PHOTOS_UPLOAD_CURRENT = 'PPO/SET_PHOTOS_UPLOAD_CURRENT';

export const UPDATE_PHOTOS_AND_MEASUREMENTS = 'PPO/UPDATE_MEASUREMENTS';
export const UPDATE_PHOTOS_AND_MEASUREMENTS_LOADING = 'PPO/UPDATE_MEASUREMENTS_LOADING';

export const UPDATE_PRODUCT_CATEGORIES = 'PPO/UPDATE_PRODUCT_CATEGORIES';
export const UPDATE_PRODUCT_CATEGORIES_LOADING = 'PPO/UPDATE_PRODUCT_CATEGORIES_LOADING';

export const UPDATE_ABOUT_YOU = 'PPO/UPDATE_ABOUT_YOU';
export const UPDATE_ABOUT_YOU_LOADING = 'PPO/UPDATE_ABOUT_YOU_LOADING';
export const UPDATE_ABOUT_YOU_SUBMITTING = 'PPO/UPDATE_ABOUT_YOU_SUBMITTING';

export const SET_STYLEBOARD_SUBMIT_LOADING = 'PPO/SET_STYLEBOARD_SUBMIT_LOADING';
export const SET_STYLEBOARD_SUBMIT_SUCCESS = 'PPO/SET_STYLEBOARD_SUBMIT_SUCCESS';
export const SET_STYLEBOARD_SUBMIT_ERROR = 'PPO/SET_STYLEBOARD_SUBMIT_ERROR';

export const UPDATE_SPACE_LIST = 'PPO/UPDATE_SPACE_LIST';
export const UPDATE_SPACE_LIST_LOADING = 'PPO/UPDATE_SPACE_LIST_LOADING';
export const SET_SPACELIST_PAGE = 'PPO/SET_SPACELIST_PAGE';

export const SET_SPACE_USER_ID = 'PPO/SET_SPACE_USER_ID';
export const SET_SPACE_USER_ID_LOADING = 'PPO/SET_SPACE_USER_ID_LOADING';

export const SET_STYLE_MATCH_QUIZ_COMPLETE = 'PPO/SET_STYLE_MATCH_QUIZ_COMPLETE';
export const SET_STYLE_MATCH_QUIZ_COMPLETE_LOADING = 'PPO/SET_STYLE_MATCH_QUIZ_COMPLETE_LOADING';

export const SET_LEGACY_QUIZ_RESULT = 'PPO/SET_LEGACY_STYLE_QUIZ_RESULT';
export const SET_LEGACY_QUIZ_RESULT_LOADING = 'PPO/SET_LEGACY_STYLE_QUIZ_RESULT_LOADING';

export const UPDATE_STYLEBOARD_V2 = 'PPO/UPDATE_STYLEBOARD_V2';

export const UPDATE_PPO_DATA = 'PP0/UPDATE_PPO_DATA';
export const UPDATE_PPO_DATA_LOADING = 'PP0/UPDATE_PPO_DATA_LOADING';

export const UPDATE_PPO_STATE = 'PP0/UPDATE_PPO_STATE';
export const UPDATE_PPO_STATE_LOADING = 'PP0/UPDATE_PPO_STATE_LOADING';
